import { ContentService } from '@blk/cwp-ng-framework';

import { LabelFormatter } from './label-formatter';

export class RegionLabelFormatter extends LabelFormatter {
	public static RegionDefaultDCR: any = {
		EXPOSURE_REGION_Unknown: 'Unknown',
		EXPOSURE_REGION_americas: 'Americas',
		EXPOSURE_REGION_northAmerica: 'North America',
		EXPOSURE_REGION_latinAmerica: 'Latin America',
		EXPOSURE_REGION_greaterEurope: 'Greater Europe',
		EXPOSURE_REGION_africaAndMiddleEast: 'Africa/Middle East',
		EXPOSURE_REGION_europeDeveloped: 'Europe Developed',
		EXPOSURE_REGION_europeEmerging: 'Europe Emerging',
		EXPOSURE_REGION_unitedKingdom: 'United Kingdom',
		EXPOSURE_REGION_greaterAsia: 'Greater Asia',
		EXPOSURE_REGION_japan: 'Japan',
		EXPOSURE_REGION_australia: 'Australia',
		EXPOSURE_REGION_australasia: 'Australasia',
		EXPOSURE_REGION_asiaDeveloped: 'Asia Developed',
		EXPOSURE_REGION_asiaEmerging: 'Asia Emerging',
		EXPOSURE_REGION_other: 'Other',
		EXPOSURE_REGION_canada: 'Canada',
		EXPOSURE_REGION_unitedStates: 'United States'
	};

	public format(value: any, contentSvc?: ContentService): string {
		const dcrKey = 'EXPOSURE_REGION_' + value;
		let codeDefaultValue = value;

		if (RegionLabelFormatter.RegionDefaultDCR.hasOwnProperty(dcrKey)) {
			codeDefaultValue = RegionLabelFormatter.RegionDefaultDCR[dcrKey];
		}

		return contentSvc.get(dcrKey, codeDefaultValue);
	}
}
